var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 1.70703C10.2348 1.70703 9.98043 1.81239 9.79289 1.99992L2.29289 9.49992C2.20003 9.59278 2.12637 9.70302 2.07612 9.82435C2.02587 9.94567 2 10.0757 2 10.207V12.9999C2 13.2651 2.10536 13.5195 2.29289 13.707C2.48043 13.8946 2.73478 13.9999 3 13.9999H6C6.13261 13.9999 6.25979 13.9472 6.35355 13.8535L12.3513 7.85573C12.3521 7.85499 12.3528 7.85424 12.3536 7.85349C12.3543 7.85274 12.355 7.85199 12.3558 7.85124L14 6.20703C14.1875 6.01949 14.2929 5.76514 14.2929 5.49992C14.2929 5.23471 14.1875 4.98035 14 4.79282L11.2071 1.99992L10.8728 2.33419L11.2071 1.99992C11.0196 1.81239 10.7652 1.70703 10.5 1.70703ZM12 6.79282L13.2929 5.49992L10.5 2.70703L9.2071 3.99993L12 6.79282ZM8.49999 4.70704L3 10.207L3 12.9999H5.79289L11.2929 7.49993L8.49999 4.70704Z",
    fill: "#22264C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPencil);
export default __webpack_public_path__ + "static/media/ic_pencil.a114d44b.svg";
export { ForwardRef as ReactComponent };